export default class AnalyticsConsentModal {
  constructor(wpstgObject = wpstg) {
    this.wpstgObject = wpstgObject;
    this.isLearnMoreLink = false;
    this.init();
  }

  init() {
    this.consentModalWrapper = document.querySelector('.wpstg-consent-modal-main-wrapper');
    this.consentModalLearnMoreLink = document.querySelector('#wpstg-admin-notice-learn-more');
    this.consentModalPermissionList = document.querySelector('#wpstg-consent-modal-permission-list');
    this.consentModalSkipLink = document.querySelector('#wpstg-skip-activate-notice');
    this.consentModalGiveConsentButton = document.querySelector('#wpstg-consent-modal-btn-success');
    this.addEvents();
  }
  addEvents() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.hide(this.consentModalWrapper);
        this.hide(this.consentModalPermissionList);
      }
    });
    this.consentModalSkipLink.addEventListener('click', () => {
      this.hide(this.consentModalWrapper);
      this.hide(this.consentModalPermissionList);
      location.href = this.wpstgObject.analyticsConsentDeny;
    });
    this.consentModalLearnMoreLink.addEventListener('click', () => {
      this.isLearnMoreLink = !this.isLearnMoreLink;
      if (this.isLearnMoreLink) {
        this.consentModalLearnMoreLink.innerHTML = 'Read Less';
        this.show(this.consentModalPermissionList);
        return false;
      }
      this.consentModalLearnMoreLink.innerHTML = 'Read More';
      this.hide(this.consentModalPermissionList);
    });
    this.consentModalGiveConsentButton.addEventListener('click', () => {
      this.hide(this.consentModalWrapper);
      this.hide(this.consentModalPermissionList);
      location.href = this.wpstgObject.analyticsConsentAllow;
    });
  }

  show(element) {
    element.style.display = 'block';
  }

  hide(element) {
    element.style.display = 'none';
  }
}
new AnalyticsConsentModal();
